import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../app/shared/models/users';
import { environment } from '../environments/environment';
import { SharedService } from '../app/shared/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import moment from 'moment';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  protected currentUserSubject: BehaviorSubject<User>;
  public currentUser: BehaviorSubject<User>;
  usersInitial:string='';
  private boundClick = () => this.logLastActivityTime();
  private boundMousemove = () => this.logLastActivityTime();
  private boundKeypress = () => this.logLastActivityTime();
  private boundScroll = () => this.logLastActivityTime();
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private dialog : MatDialog,
    private readonly cookies: CookieService,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject;
    this.listenUserActivities();
  }

  private host = environment.host();

  public get currentUserValue(): User {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    return this.currentUserSubject.value;
  }
  isSessionExpired: boolean = false;
  expirationListener: any;
  login(request: any) {
    // this.currentUserSubject.subscribe();
    return this.http.post<any>(this.host + 'login/', request).pipe(
      map((user) => {
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          if (user.role.code == 'SPONSOR_REPRESENTATIVE') {
            user.login_time = new Date().getTime();
            user.tokenExpireTime = user.login_time + (Number(user.expires_in) - 600) * 1000;
            user.header = true;
            localStorage.setItem('currentUser', JSON.stringify(user));
            localStorage.setItem('for_2fa_only', user['Two-FA-Token']);
            this.currentUserSubject.next(user);
            this.currentUser.next(user);
            // this.getUserInitial();
          } else {
            this.logoutUser();
          }
        } else if (user && user['Two-FA-Token']) {
          user.login_time = new Date().getTime();
          user.tokenExpireTime = user.login_time + (Number(user.expires_in) - 600) * 1000;
          user.header = true;
          localStorage.setItem('currentUser', JSON.stringify(user));
          localStorage.setItem('for_2fa_only', user['Two-FA-Token']);
          this.currentUserSubject.next(user);
          this.currentUser.next(user);
          this.setExpirationTime(Number(user.expires_in));
          // this.getUserInitial();
        }


        return user;
      })
    );
  }
  getUserInitial(){
    if((this.currentUser.value.user.first_name && this.currentUser.value.user.first_name!=='') || (this.currentUser.value.user.last_name && this.currentUser.value.user.last_name!=='')){
      this.usersInitial = 
      (this.currentUser.value.user.first_name?.charAt(0).toUpperCase() || '') +
      (this.currentUser.value.user.last_name?.charAt(0).toUpperCase() || '');  
      localStorage.setItem('usersInitial',JSON.stringify(this.usersInitial))
    }
  }
  getProgramInfo() {
    this.http.get(`${environment.host()}programs/`).subscribe({
      next: (res: any) => {
        localStorage.setItem('programInfo', JSON.stringify(res));
        localStorage.setItem('program_date_format', JSON.stringify(res[0].date_format));
        this.sharedService.getCurrencySymbol();
      }
    });
  }
  logoutUser() {
    this.sharedService.toggleGlobalLoader(true);
    const requestUrl = environment.host() + 'logout/';
    this.http
      .post(requestUrl, {})
      .pipe(catchError((err) => of(err)))
      .subscribe({
        next: () => {
          this.clearCredentials();
          this.dialog.closeAll();
          this.sharedService.toggleGlobalLoader(false);
        },error : (error) => {
          this.sharedService.toggleGlobalLoader(false);
        }
      });
  }

  clearCredentials() {
    localStorage.removeItem('currentUser');
    var emptyuser: any = {};
    localStorage.clear();
    this.currentUserSubject.next(emptyuser);
    this.currentUser.next(emptyuser);
    this.removeUserActivityListeners();
    location.reload();
    this.cookies.deleteAll();
  }

  updateCurrentUserObs(user: any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUser.next(user);
    this.currentUserSubject.next(user);
  }

  getCurrentUserObs() {
    return this.currentUserSubject;
  }

  getTenantDetail() {
    return this.http.get(this.host + 'tenants/basic-info/');
  }
  
  setExpirationTime(expirationtime: number) {
  const logintime = new Date().getTime();
  const expiretime = logintime + (expirationtime - 600) * 1000;
  const tokentimeout = logintime + expirationtime * 1000;
  const cookieExpiryDate = new Date(tokentimeout);
  this.cookies.set('loginTime', logintime.toString(), cookieExpiryDate, '/');
  this.cookies.set('expirationalerttime', expiretime.toString(), cookieExpiryDate, '/');
  this.cookies.set('tokentimeout', tokentimeout.toString(), cookieExpiryDate, '/');
  this.cookies.set('reauthentication', JSON.stringify(true), cookieExpiryDate, '/');
  this.listenTokenExpiry();
  }

  listenTokenExpiry() {
    const currentUser = localStorage.getItem('currentUser');
    if (this.expirationListener) {
      clearInterval(this.expirationListener);
    }
    if (currentUser == null || currentUser == undefined) {
      if (
        !(location.href.includes('login') || location.href.includes('auth'))
      ) {
        location.href = '/#/login';
      }
      return;
    }
    this.expirationListener = setInterval(() => {
      this.validateSession();
      if (this.isUserInactive) {
        this.clearCredentials();
        this.logoutUser();
      }
    }, 1000);
  }

  validateSession() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser == null || currentUser == undefined) {
      clearInterval(this.expirationListener);
      if (!location.href.includes('login')) {
        location.href = '/#/login';
      }
      return;
    }
    const currentTime = new Date().getTime();
    const tokenTimeOut = parseInt(this.cookies.get('tokentimeout'));
    if (currentTime >= tokenTimeOut) {
      clearInterval(this.expirationListener);
      this.isSessionExpired = true;
      this.logoutUser();
    }
  }
  get isUserInactive() {
    const lastActivityTime = localStorage.getItem('lastActivityTime');
    if (lastActivityTime) {
      const currentTime = moment();
      const lastActivity = moment(lastActivityTime);
      const inactivitySessionPeriod = parseInt(
        localStorage.getItem('inactivitySessionPeriod') ?? '0'
      );
      if (inactivitySessionPeriod > 0)
        return (
          currentTime.diff(lastActivity, 'seconds') >
          inactivitySessionPeriod * 60
        );
    }
    return false;
  }
  listenUserActivities() {
    document.addEventListener(
      'click',
      () => {
        this.logLastActivityTime();
      },
      true
    );
    document.addEventListener(
      'mousemove',
      () => {
        this.logLastActivityTime();
      },
      true
    );
    document.addEventListener(
      'keypress',
      () => {
        this.logLastActivityTime();
      },
      true
    );
    document.addEventListener('scroll', () => {
      this.logLastActivityTime();
    });
  }
  logLastActivityTime() {
    localStorage.setItem('lastActivityTime', moment().toString());
  }
  removeUserActivityListeners() {
    document.removeEventListener('click', this.boundClick, true);
    document.removeEventListener('mousemove', this.boundMousemove, true);
    document.removeEventListener('keypress', this.boundKeypress, true);
    document.removeEventListener('scroll', this.boundScroll, true);
  }
}
